import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagSM = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25c1.087 0 25-3.26 25-3.26L50 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M0 25C0 11.193 11.193 0 25 0s25 11.193 25 25"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M34.922 17.25 25 27.174l-9.923-9.924a11.887 11.887 0 0 0-2.034 6.663v3.26c0 5.237 3.384 9.697 8.079 11.311a3.616 3.616 0 0 0 .397 3.907l3.553-2.848 3.553 2.848A3.617 3.617 0 0 0 29 38.44c4.631-1.65 7.955-6.077 7.955-11.267v-3.261c0-2.465-.75-4.758-2.033-6.663Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 35.869c-4.795 0-8.696-3.9-8.696-8.696v-3.26c0-4.795 3.901-8.696 8.696-8.696 4.794 0 8.695 3.9 8.695 8.696v3.26c0 4.795-3.9 8.696-8.695 8.696Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M30.435 27.174v-3.26a5.44 5.44 0 0 0-5.434-5.435 5.441 5.441 0 0 0-5.435 5.434v3.261l5.435 1.087 5.434-1.087Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M19.566 27.174a5.44 5.44 0 0 0 5.435 5.435 5.44 5.44 0 0 0 5.434-5.435H19.566Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M31.522 15.217a3.26 3.26 0 0 0-5.435-2.43V10.87h1.087V8.695h-1.087V7.608h-2.174v1.087h-1.086v2.174h1.086v1.918a3.26 3.26 0 1 0-4.348 4.86v1.918h10.87v-1.918a3.252 3.252 0 0 0 1.087-2.43Z"
}));
FlagSM.displayName = 'FlagSM';
export default withFlagWrapper(FlagSM);
//# sourceMappingURL=index.js.map